export interface IAreaProps {
  id: string
  hospitalId: string
  name: string
  beaconX: number
  beaconY: number
  areaX: number
  areaY: number
  areaWidth: number
  areaHeight: number
  fixed: boolean
}

export default class AreaEntity {
  private _props: IAreaProps

  constructor(props: IAreaProps) {
    this._props = props
  }

  get props(): IAreaProps {
    return this._props
  }

  get id(): string {
    return this._props.id
  }

  get name(): string {
    return this._props.name
  }

  get beaconX(): number {
    return this._props.beaconX
  }

  get beaconY(): number {
    return this._props.beaconY
  }

  get areaX(): number {
    return this._props.areaX
  }

  get areaY(): number {
    return this._props.areaY
  }

  get areaWidth(): number {
    return this._props.areaWidth
  }

  get areaHeight(): number {
    return this._props.areaHeight
  }

  get fixed(): boolean {
    return this._props.fixed
  }
}

export const headers = [
  { text: 'ID', value: 'id' },
  { text: 'タイトル', value: 'name' },
  { text: '順番', value: 'order' },
  { text: '', value: 'actions', sortable: false, width: '80' }
]

export const EmptyAreaPropsFactory = (props?: Partial<IAreaProps>): IAreaProps => ({
  id: '',
  hospitalId: '',
  name: '',
  beaconX: 0,
  beaconY: 0,
  areaX: 0,
  areaY: 0,
  areaWidth: 0,
  areaHeight: 0,
  fixed: false,
  ...props
})

export const EmptyAreaEntityFactory = (props?: Partial<IAreaProps>): AreaEntity => {
  return new AreaEntity(EmptyAreaPropsFactory(props))
}
